/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_PathInputs */

const cs_blog_website_path = /** @type {(inputs: Blog_Website_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejná URL cesta`)
};

const en_blog_website_path = /** @type {(inputs: Blog_Website_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public URL path`)
};

/**
* | output |
* | --- |
* | "Public URL path" |
*
* @param {Blog_Website_PathInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_path = /** @type {((inputs?: Blog_Website_PathInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_PathInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_path(inputs)
	return cs_blog_website_path(inputs)
});